import { combineReducers } from "redux"

function networkAvailable(state = true, action) {
  switch (action.type) {
    case "APOLLO_QUERY_ERROR":
    case "APOLLO_MUTATION_ERROR":
      return action.error.message !== "Failed to fetch"
    case "APOLLO_QUERY_RESULT":
      return true
    default:
      return state
  }
}

export default combineReducers({
  networkAvailable
})



// WEBPACK FOOTER //
// ./src/Network/reducer.js